<template>
  <UlDialog
    v-model="dialog"
    width="800"
    title-left
    :title="$t('dataProcessing.privacyPolicyTitle')"
  >
    <template #text>
      <div v-html="$t(contentIdx)"></div>
    </template>
  </UlDialog>
</template>

<script>
export default {
  name: 'DynamicPrivacyPolicyModal',
  props: {
    contentIdx: {
      type: String,
      required: true
    },
    identifier: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  created() {
    this.$eventHub.$on(
      `openPrivacyPolicyModal${this.identifier ? `_${this.identifier}` : ''}`,
      () => {
        this.dialog = true;
      }
    );
  },
  beforeDestroy() {
    this.$eventHub.$off(`openPrivacyPolicyModal${this.identifier ? `_${this.identifier}` : ''}`);
  }
};
</script>
